import React, { useId } from 'react';
import './AiSparkIcon.css';

/** 모든 AI 버튼 공통 아이콘(반짝임) — 무지개 그라데이션 */
const AiSparkIcon: React.FC<{ size?: number; className?: string }> = ({ size = 14, className }) => {
  const id = `cp-ai-spark-${useId().replace(/:/g, '')}`;
  return (
    <svg className={`cp-ai-spark${className ? ` ${className}` : ''}`} viewBox="0 0 16 16" width={size} height={size} fill="none" aria-hidden focusable="false">
      <defs>
        <linearGradient id={id} x1="1" y1="1" x2="15" y2="15" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ff6b6b" />
          <stop offset=".22" stopColor="#ffb547" />
          <stop offset=".42" stopColor="#f4c430" />
          <stop offset=".6" stopColor="#4ade80" />
          <stop offset=".8" stopColor="#38bdf8" />
          <stop offset="1" stopColor="#a78bfa" />
        </linearGradient>
      </defs>
      <path d="M8 1.5l1.4 3.6 3.6 1.4-3.6 1.4L8 11.5 6.6 7.9 3 6.5l3.6-1.4L8 1.5z" fill={`url(#${id})`} />
      <path d="M12.5 10.5l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6.6-1.4z" fill={`url(#${id})`} />
    </svg>
  );
};

export default AiSparkIcon;
